
namespace GeniuzPOS.AdvPromo {

    @Serenity.Decorators.registerClass()
    export class Report_Adv02Dialog extends Serenity.EntityDialog<Report_Adv02Row, any> {
        protected getFormKey() { return Report_Adv02Form.formKey; }
        protected getIdProperty() { return Report_Adv02Row.idProperty; }
        protected getLocalTextPrefix() { return Report_Adv02Row.localTextPrefix; }
        protected getNameProperty() { return Report_Adv02Row.nameProperty; }
        protected getService() { return Report_Adv02Service.baseUrl; }
        protected getDeletePermission() { return Report_Adv02Row.deletePermission; }
        protected getInsertPermission() { return Report_Adv02Row.insertPermission; }
        protected getUpdatePermission() { return Report_Adv02Row.updatePermission; }

        protected form = new Report_Adv02Form(this.idPrefix);

    }
}